var exports = {
  "k": "x31de4314--795f8a--container",
  "n": "x31de4314--795f8a--link",
};

module.exports = exports;
